import { render, staticRenderFns } from "./upload-assessment-button.vue?vue&type=template&id=595e4176"
import script from "./upload-assessment-button.vue?vue&type=script&lang=js"
export * from "./upload-assessment-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports